var exports = {
  "Q": "content__qzpJuc",
};

module.exports = exports;
